var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-class page-setting-form"},[_c('div',{staticClass:"comments-outside"},[_c('div',{staticClass:"comments-header dark-div"}),_c('comment-box',{attrs:{"tag":_vm.tag,"comments_wrapper_classes":['custom-scrollbar', 'comments-wrapper'],"comments":_vm.comments},on:{"submit-comment":_vm.submitComment,"close":_vm.onClose}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }